import {m} from '@codeurs/front'
import {forwardRef, HTMLProps, Ref} from 'react'
import {NavLink} from 'react-router-dom'
import parse from 'url-parse'
import {ClassName} from 'util/style'

export type PageLinkProps = {to?: string} & Omit<
  HTMLProps<HTMLAnchorElement>,
  'className'
> & {
    className?: ClassName | string
    exact?: boolean
    replace?: boolean
  }

export const PageLink = forwardRef(
  (props: PageLinkProps, ref: Ref<HTMLAnchorElement>) => {
    const {children, as, to, ...rest} = props
    const href = to
    const parsed = parse(href)
    const isFile = parsed.pathname.split('/').pop().includes('.')
    const isExternal = parsed.hostname !== window.location.hostname
    const Tag: any =
      as || (href ? (isFile || isExternal ? 'a' : NavLink) : 'span')
    const attrs =
      isFile || isExternal
        ? href
          ? {
              href,
              ref,
              target: isExternal || isFile ? '_blank' : '_self',
              rel: isExternal ? 'external nofollow noopener' : undefined
            }
          : {}
        : {to: href, innerRef: ref, activeClassName: 'is-active'}
    return (
      <Tag {...attrs} {...rest}>
        {children}
      </Tag>
    )
  }
)

export const isActiveNav = path => {
  let cleanPath = path.replace(/^\/*/g, '')
  let checkLocation = window.location.host + window.location.pathname
  if (cleanPath.indexOf(window.location.host) < 0) {
    checkLocation = window.location.pathname
    cleanPath = '/' + cleanPath
  }
  // handle CMS preview links
  checkLocation = checkLocation.replace(/\/(nl|fr|en)\//, '/')
  cleanPath = cleanPath.replace(/\/(nl|fr|en)\//, '/')
  return checkLocation.indexOf(cleanPath) === 0
}
